module.exports = __webpack_public_path__ + "img/owner3.8a193e0b.jpg";